import React from "react"
import CurrencyContext from "../../context/CurrencyContext"
import { useStaticQuery, graphql } from "gatsby"

const Pricing = ({
  CurrencyPrefix,
  pricing,
  productID,
  billingCycle = "monthly",
}) => {
  const allData = useStaticQuery(graphql`
    query {
      allPromotionsJson {
        edges {
          node {
            code
            value
            appliesto
            cycles
            expirationdate
          }
        }
      }
    }
  `)

  const allPromoData = allData.allPromotionsJson.edges

  if (allPromoData.length <= 0) {
    return null
  }

  if (
    [16, 17, 18, 19, 50, 55, 56, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 110].includes(
      productID
    )
  ) {
    billingCycle = "annually"
  }

  return (
    <CurrencyContext.Consumer>
      {(context) => {
        const currencyKey = context.defaultValue.toUpperCase()
        const currency = pricing[currencyKey] || pricing.INR
        const currpref = CurrencyPrefix[currencyKey] || CurrencyPrefix.INR

        let selectedPricing = currency[billingCycle] || 0
        let tenureShortForm = "/mo"

        if (billingCycle === "annually") {
          tenureShortForm = "/yr"
        }

        const currentDate = new Date()

        let discountedPrice = selectedPricing // Initialize discounted price with selected price

        // Loop through promotions to find applicable discount
        allPromoData.forEach((promotionItem) => {
          const arrayPromotionProductIDs =
            promotionItem.node.appliesto.split(",")

          // Check if promotion applies to the current product and billing cycle
          const isPromotionApplicableForProductID =
            productID &&
            arrayPromotionProductIDs.includes(productID.toString()) &&
            promotionItem.node.cycles
              .toUpperCase()
              .includes(billingCycle.toUpperCase()) &&
            currentDate <= new Date(promotionItem.node.expirationdate)

          // Apply discount if promotion is applicable
          if (isPromotionApplicableForProductID) {
            const discountValue = promotionItem.node.value / 100 // Convert percentage discount to decimal
            discountedPrice = selectedPricing * (1 - discountValue)
          }
        })

        return (
          <>
            <div className="fs-32 fw-bolder">
              {discountedPrice === 0.0 ? (
                "Free"
              ) : (
                <>
                  <span className="ps-0 pe-1">{currpref.prefix}</span>
                  {Number(discountedPrice).toFixed(2)}
                  <span className="fs-16">{tenureShortForm}</span>
                </>
              )}
            </div>
          </>
        )
      }}
    </CurrencyContext.Consumer>
  )
}

export default Pricing
